import { Controller } from "@hotwired/stimulus"

// curator-carousel
// Smooth-transform carousel for the dashboard Curator slideshow.
// 3 slides max, manual navigation only (arrows + dots).
export default class extends Controller {
  static targets = ["track", "slide", "dot"]
  static values  = { total: Number }

  connect() {
    console.log(`[curator-carousel] connect: total=${this.totalValue}`)
    this.currentIndex = 0
    this.updateDots()
  }

  next() {
    console.log(`[curator-carousel] next from ${this.currentIndex}`)
    if (this.currentIndex < this.totalValue - 1) {
      this.goTo(this.currentIndex + 1)
    }
  }

  prev() {
    console.log(`[curator-carousel] prev from ${this.currentIndex}`)
    if (this.currentIndex > 0) {
      this.goTo(this.currentIndex - 1)
    }
  }

  go(event) {
    const index = parseInt(event.currentTarget.dataset.index, 10)
    console.log(`[curator-carousel] go to ${index}`)
    if (!Number.isNaN(index) && index !== this.currentIndex) {
      this.goTo(index)
    }
  }

  goTo(index) {
    this.currentIndex = index
    const offsetPct = -index * 100
    this.trackTarget.style.transform = `translateX(${offsetPct}%)`
    this.updateDots()
  }

  updateDots() {
    this.dotTargets.forEach((dot, i) => {
      if (i === this.currentIndex) {
        dot.classList.remove("w-2", "bg-gray-300", "dark:bg-gray-600")
        dot.classList.add("w-6", "bg-brand")
      } else {
        dot.classList.remove("w-6", "bg-brand")
        dot.classList.add("w-2", "bg-gray-300", "dark:bg-gray-600")
      }
    })
  }

  disconnect() {
    console.log(`[curator-carousel] disconnect`)
  }
}
